module.exports = __webpack_public_path__ + "img/icon_utill_arrow.4bb9ffdf.svg";